import {
  Conditions,
  ContactPeopleCondition,
  StatusCondition,
  StatusConditionItem,
  StatusUpdatedCondition,
  FirstInterviewDateCondition,
  SourcingRouteId,
} from '../reducers/condition'
import { MyLabelId } from '../reducers/sourcingAnnotationCandidates'
import { Action } from './type'

export type StatusConditionAction = Action & {
  type:
    | 'OPEN_STATUS_CONDITION'
    | 'SELECT_FILTER_STATUS_CONDITION'
    | 'SELECT_FILTER_STATUS_UPDATED'
    | 'SELECT_FILTER_FIRST_INTERVIEW_DATE'
    | 'SELECT_FILTER_SOURCING_ROUTE'
    | 'SELECT_FILTER_MY_LABEL'
    | 'SET_INIT_STATUS_CONDITION'
    | 'SET_INIT_STATUS_UPDATED_AT'
    | 'SET_INIT_SOURCING_ROUTE_CONDITION'
    | 'SET_INIT_CONTACT_PERSON_CONDITION'
    | 'SET_INIT_FIRST_INTERVIEW_DATE'
    | 'SET_INIT_MY_LABEL_CONDITION'
}

export const OPEN_STATUS_CONDITION = 'OPEN_STATUS_CONDITION'
export function openStatusCondition(payload: StatusConditionItem | null) {
  return { type: OPEN_STATUS_CONDITION, payload }
}

export const SELECT_FILTER_STATUS_CONDITION = 'SELECT_FILTER_STATUS_CONDITION'
export function selectFilterStatusCondition(payload: {
  itemName: StatusConditionItem
  conditions: Conditions
}) {
  return { type: SELECT_FILTER_STATUS_CONDITION, payload }
}

export const SELECT_FILTER_STATUS_UPDATED = 'SELECT_FILTER_STATUS_UPDATED'
export function selectFilterStatusUpdated(payload: StatusUpdatedCondition) {
  return { type: SELECT_FILTER_STATUS_UPDATED, payload }
}

export const SELECT_FILTER_FIRST_INTERVIEW_DATE =
  'SELECT_FILTER_FIRST_INTERVIEW_DATE'
export function selectFilterFirstInterviewDate(
  payload: FirstInterviewDateCondition
) {
  return { type: SELECT_FILTER_FIRST_INTERVIEW_DATE, payload }
}

export const SELECT_FILTER_SOURCING_ROUTE = 'SELECT_FILTER_SOURCING_ROUTE'
export function selectFilterSourcingRoute(payload: { id: number }) {
  return { type: SELECT_FILTER_SOURCING_ROUTE, payload }
}

export const SELECT_FILTER_MY_LABEL = 'SELECT_FILTER_MY_LABEL'
export function selectFilterMyLabel(payload: MyLabelId) {
  return { type: SELECT_FILTER_MY_LABEL, payload }
}

export const SET_INIT_STATUS_CONDITION = 'SET_INIT_STATUS_CONDITION'
export function setInitStatusCondition(conditions: StatusCondition[]) {
  return { type: SET_INIT_STATUS_CONDITION, payload: conditions }
}

export const SET_INIT_STATUS_UPDATED_AT = 'SET_INIT_STATUS_UPDATED_AT'
export function setInitStatusUpdatedAt(condition: StatusUpdatedCondition) {
  return { type: SET_INIT_STATUS_UPDATED_AT, payload: condition }
}

export const SET_INIT_FIRST_INTERVIEW_DATE = 'SET_INIT_FIRST_INTERVIEW_DATE'
export function setInitFirstInterviewDate(
  condition: FirstInterviewDateCondition
) {
  return { type: SET_INIT_FIRST_INTERVIEW_DATE, payload: condition }
}

export const SET_INIT_CONTACT_PERSON_CONDITION =
  'SET_INIT_CONTACT_PERSON_CONDITION'
export function setInitContactPersonCondition(
  conditions: ContactPeopleCondition[]
) {
  return { type: SET_INIT_CONTACT_PERSON_CONDITION, payload: conditions }
}

export const SET_INIT_SOURCING_ROUTE_CONDITION =
  'SET_INIT_SOURCING_ROUTE_CONDITION'
export function setInitSourcingRoutesCondition(conditions: SourcingRouteId[]) {
  return { type: SET_INIT_SOURCING_ROUTE_CONDITION, payload: conditions }
}

export const SET_INIT_MY_LABEL_CONDITION = 'SET_INIT_MY_LABEL_CONDITION'
export function setInitMyLabelCondition(conditions: MyLabelId[]) {
  return { type: SET_INIT_MY_LABEL_CONDITION, payload: conditions }
}
